/**
 * CompanionApp — Welle 8c Phase A
 *
 * Eigener Einstieg für den Companion-Modus (?companion=1), bewusst getrennt von
 * <App/>: hier laufen KEINE Agent-Hintergrund-Hooks (Klingelton, useAgentSocket,
 * Reachability, WakeLock …). Insbesondere würde useAgentSocket den Companion sonst
 * als verfügbaren Berater registrieren und ihm eingehende Anrufe zustellen.
 *
 * Ablauf: Login (gleiche Berater-Anmeldung) → danach die Companion-Oberfläche,
 * die sich an den aktiven Call der Berater-Session hängt.
 */

import { useEffect, useState } from 'react';
import { Login } from '@/views/Login';
import { Companion } from '@/views/Companion';
import { isTokenValid } from '@/lib/auth';

export default function CompanionApp() {
  // Auth-Status selbstständig reaktiv halten: Login schreibt den Token in den
  // localStorage. Da das kein React-State ist, prüfen wir isTokenValid() periodisch
  // (und bei Fokus) — sonst bliebe nach dem Login die Login-Seite stehen, bis F5.
  const [authed, setAuthed] = useState(() => isTokenValid());
  useEffect(() => {
    const check = () => setAuthed(isTokenValid());
    check();
    const id = setInterval(check, 500);
    window.addEventListener('focus', check);
    return () => { clearInterval(id); window.removeEventListener('focus', check); };
  }, []);

  if (!authed) {
    return (
      <div className="app minimal">
        <Login />
      </div>
    );
  }
  return <Companion />;
}
